var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgTokenFinix(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05E75",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D62838",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.473%",
    y1: "49.947%",
    x2: "71.629%",
    y2: "49.947%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CA64",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2B13A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.608%",
    y1: "49.975%",
    x2: "71.721%",
    y2: "49.975%",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CA64",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2B13A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.401%",
    y1: "50.006%",
    x2: "71.298%",
    y2: "50.006%",
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CA64",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2B13A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "n"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9CA64",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2B13A",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A72BA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26A7DF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-11891.596%",
    y1: "50%",
    x2: "-11791.596%",
    y2: "50%",
    id: "t"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23B182",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BBF95",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.765c0 .974.78 1.764 1.741 1.764.962 0 1.741-.79 1.741-1.764C3.482.79 2.702 0 1.742 0 .78 0 0 .79 0 1.765",
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.038.088v.018a.526.526 0 0 0 .056-.08C.09.026.038.088.038.088",
    id: "d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.095.106V.09S.04.026.038.026c-.002 0 .01.02.057.08",
    id: "g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.095.106V.09S.04.026.038.026a.6.6 0 0 0 .057.08",
    id: "j"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.072.772c-.235.186-.447.401-.63.64a2.126 2.126 0 0 1-.04.027l.017.002c.285.032.562.113.82.24-.077.07-.15.142-.222.218l-.01.011c-.12.129-.232.265-.334.407l-.015.023a3.888 3.888 0 0 0-.134.202l-.012.018c-.045.074-.089.15-.13.228a4.02 4.02 0 0 0-.304.75l-.016.059a5.618 5.618 0 0 0-.051.203l-.012.05a4.3 4.3 0 0 0-.044.25l-.007.054a3.79 3.79 0 0 0-.021.207 3.986 3.986 0 0 0-.014.333c0 .065.001.13.004.195l.004.064v.005l.01.124.008.077.014.114.012.08.02.108c.004.027.01.054.016.082l.023.103.02.082.028.102.023.079c.017.056.036.11.055.165l.037.096.03.074.042.099.03.066c.015.034.031.067.048.101l.03.06.054.102.03.051c.02.036.04.071.062.106l.022.035c.043.07.09.138.137.205l.018.024a3.974 3.974 0 0 0 3.225 1.659c1.993-.003 3.61 1.632 3.612 3.651.003 2.02-1.61 3.659-3.602 3.661-1.992.003-3.61-1.632-3.612-3.651a3.69 3.69 0 0 1 .635-2.077h-.001l-.001.002L1.14 8.872c-1.928 2.67-1.355 6.418 1.28 8.37a5.857 5.857 0 0 0 3.494 1.156c3.266.001 5.914-2.682 5.915-5.992a6.012 6.012 0 0 0-2.837-5.12 7.648 7.648 0 0 0-1.674-.615 6.166 6.166 0 0 0-1.404-.182 1.762 1.762 0 0 1-1.052-.354l-.017-.013a1.843 1.843 0 0 1-.092-.076 1.774 1.774 0 0 1-.25-.271l-.035-.047a1.135 1.135 0 0 1-.085-.135l-.038-.068-.042-.09-.023-.05a1.764 1.764 0 0 1-.052-.144c-.006-.017-.01-.034-.015-.052-.01-.035-.02-.07-.027-.106l-.012-.058a1.717 1.717 0 0 1-.017-.112l-.006-.052a1.807 1.807 0 0 1-.008-.167v-.02c0-.865.609-1.608 1.448-1.769.035-.007.07-.014.106-.018A1.46 1.46 0 0 1 7.34 1.628a1.47 1.47 0 0 1 1.256 1.463l-.002.035c.021-.112.033-.226.036-.34l.002-.053-.002-.056a2.053 2.053 0 0 0-.148-.716 1.798 1.798 0 0 0-.354-.555A3.579 3.579 0 0 0 5.285 0C4.51 0 3.73.252 3.072.772",
    id: "m"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.254 0c-.001.086-.23 1.707-1.156 3.328-.43.755-1.777 2.144-1.777 2.144l-.006.005h-.002c-5.348 6.998-4.087 17.064 2.816 22.485.292.23.592.448.9.656l.012.01.016.01.052.027c.85.09 1.55.714 1.749 1.556a.628.628 0 0 1 .006.019c.221-.229.406-.807.478-1.06.055-.261.07-.53.044-.796a2.496 2.496 0 0 0-.943-1.612l-.024-.02a2.888 2.888 0 0 0-.085-.066l-.007-.005C2.122 22.489.445 13.99 4.581 7.702c.171-.26.35-.514.539-.761 0 0 1.598-1.25 1.757-2.378 0 0 1.218 2.134.296 4.042C3.53 13.444 4.444 20.36 9.217 24.054c.098.075.198.15.298.222l-.002.004a32.212 32.212 0 0 1 3.346 3.127c.394.027.77.176 1.078.426.406.33.675.803.754 1.324l.003.005.01-.023c.088-.136.656-1.102.072-2.704l-.005-.013c-.486-1.216-1.92-2.515-2.925-3.316-.6-.478-1.048-.779-1.048-.779C7.2 19.687 6.19 14.695 8.471 10.83c.148-.25 2.668-3.65-.33-8.175A214.559 214.559 0 0 1 6.254 0z",
    id: "p"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.783 0C8.67.167 8.25.762 6.896 2.655c-2.999 4.525-.479 7.925-.33 8.175 2.282 3.864 1.271 8.856-2.328 11.497v-.001s-.447.301-1.047.78c-1.005.8-2.44 2.099-2.926 3.315l-.005.013c-.584 1.602-.015 2.568.073 2.704l.01.022.003-.005c.079-.52.348-.993.754-1.323.308-.25.684-.399 1.078-.426a32.215 32.215 0 0 1 3.345-3.127l-.002-.004c.1-.072.2-.146.299-.222 4.773-3.694 5.688-10.61 2.044-15.448-.923-1.908.296-4.042.296-4.042C8.318 5.69 9.917 6.94 9.917 6.94c.188.248.368.501.539.761 4.136 6.29 2.46 14.787-3.746 18.98l-.007.005a2.77 2.77 0 0 0-.085.066l-.024.02c-.51.393-.848.971-.943 1.612-.026.266-.012.535.044.796.072.253.257.831.477 1.06l.007-.019c.198-.842.9-1.466 1.75-1.556l.051-.028.017-.009h-.001l.012-.01c.307-.208.608-.427.9-.656 6.903-5.421 8.164-15.488 2.816-22.485h-.001l-.008-.005S10.37 4.082 9.94 3.328C9.012 1.707 8.784.086 8.783 0z",
    id: "s"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0zm0 .96C11.275.96.96 11.275.96 24S11.275 47.04 24 47.04 47.04 36.725 47.04 24 36.725.96 24 .96z",
    fill: "#E0E0E0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.258 22.405)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.765c0 .974.78 1.764 1.741 1.764.962 0 1.741-.79 1.741-1.764C3.482.79 2.702 0 1.742 0 .78 0 0 .79 0 1.765",
    fill: "url(#b)",
    mask: "url(#c)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.485 12.545)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.038.088v.018a.526.526 0 0 0 .056-.08C.09.026.038.088.038.088",
    fill: "url(#e)",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.232 18.829)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.095.106V.09S.04.026.038.026c-.002 0 .01.02.057.08",
    fill: "url(#h)",
    mask: "url(#i)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.49 12.548)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.095.106V.09S.04.026.038.026a.6.6 0 0 0 .057.08",
    fill: "url(#k)",
    mask: "url(#l)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F0637C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.523 12.635v.017c.128-.172 0-.017 0-.017M20.326 18.936v-.016s-.125-.156 0 .016M12.584 12.64s-.129-.156 0 .015v-.016z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.084 11.767)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.072.772c-.235.186-.447.401-.63.64a2.126 2.126 0 0 1-.04.027l.017.002c.285.032.562.113.82.24-.077.07-.15.142-.222.218l-.01.011c-.12.129-.232.265-.334.407l-.015.023a3.888 3.888 0 0 0-.134.202l-.012.018c-.045.074-.089.15-.13.228a4.02 4.02 0 0 0-.304.75l-.016.059a5.618 5.618 0 0 0-.051.203l-.012.05a4.3 4.3 0 0 0-.044.25l-.007.054a3.79 3.79 0 0 0-.021.207 3.986 3.986 0 0 0-.014.333c0 .065.001.13.004.195l.004.064v.005l.01.124.008.077.014.114.012.08.02.108c.004.027.01.054.016.082l.023.103.02.082.028.102.023.079c.017.056.036.11.055.165l.037.096.03.074.042.099.03.066c.015.034.031.067.048.101l.03.06.054.102.03.051c.02.036.04.071.062.106l.022.035c.043.07.09.138.137.205l.018.024a3.974 3.974 0 0 0 3.225 1.659c1.993-.003 3.61 1.632 3.612 3.651.003 2.02-1.61 3.659-3.602 3.661-1.992.003-3.61-1.632-3.612-3.651a3.69 3.69 0 0 1 .635-2.077h-.001l-.001.002L1.14 8.872c-1.928 2.67-1.355 6.418 1.28 8.37a5.857 5.857 0 0 0 3.494 1.156c3.266.001 5.914-2.682 5.915-5.992a6.012 6.012 0 0 0-2.837-5.12 7.648 7.648 0 0 0-1.674-.615 6.166 6.166 0 0 0-1.404-.182 1.762 1.762 0 0 1-1.052-.354l-.017-.013a1.843 1.843 0 0 1-.092-.076 1.774 1.774 0 0 1-.25-.271l-.035-.047a1.135 1.135 0 0 1-.085-.135l-.038-.068-.042-.09-.023-.05a1.764 1.764 0 0 1-.052-.144c-.006-.017-.01-.034-.015-.052-.01-.035-.02-.07-.027-.106l-.012-.058a1.717 1.717 0 0 1-.017-.112l-.006-.052a1.807 1.807 0 0 1-.008-.167v-.02c0-.865.609-1.608 1.448-1.769.035-.007.07-.014.106-.018A1.46 1.46 0 0 1 7.34 1.628a1.47 1.47 0 0 1 1.256 1.463l-.002.035c.021-.112.033-.226.036-.34l.002-.053-.002-.056a2.053 2.053 0 0 0-.148-.716 1.798 1.798 0 0 0-.354-.555A3.579 3.579 0 0 0 5.285 0C4.51 0 3.73.252 3.072.772",
    fill: "url(#n)",
    mask: "url(#o)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.16 8.88)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.254 0c-.001.086-.23 1.707-1.156 3.328-.43.755-1.777 2.144-1.777 2.144l-.006.005h-.002c-5.348 6.998-4.087 17.064 2.816 22.485.292.23.592.448.9.656l.012.01.016.01.052.027c.85.09 1.55.714 1.749 1.556a.628.628 0 0 1 .006.019c.221-.229.406-.807.478-1.06.055-.261.07-.53.044-.796a2.496 2.496 0 0 0-.943-1.612l-.024-.02a2.888 2.888 0 0 0-.085-.066l-.007-.005C2.122 22.489.445 13.99 4.581 7.702c.171-.26.35-.514.539-.761 0 0 1.598-1.25 1.757-2.378 0 0 1.218 2.134.296 4.042C3.53 13.444 4.444 20.36 9.217 24.054c.098.075.198.15.298.222l-.002.004a32.212 32.212 0 0 1 3.346 3.127c.394.027.77.176 1.078.426.406.33.675.803.754 1.324l.003.005.01-.023c.088-.136.656-1.102.072-2.704l-.005-.013c-.486-1.216-1.92-2.515-2.925-3.316-.6-.478-1.048-.779-1.048-.779C7.2 19.687 6.19 14.695 8.471 10.83c.148-.25 2.668-3.65-.33-8.175A214.559 214.559 0 0 1 6.254 0z",
    fill: "url(#q)",
    mask: "url(#r)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.803 8.88)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "u",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.783 0C8.67.167 8.25.762 6.896 2.655c-2.999 4.525-.479 7.925-.33 8.175 2.282 3.864 1.271 8.856-2.328 11.497v-.001s-.447.301-1.047.78c-1.005.8-2.44 2.099-2.926 3.315l-.005.013c-.584 1.602-.015 2.568.073 2.704l.01.022.003-.005c.079-.52.348-.993.754-1.323.308-.25.684-.399 1.078-.426a32.215 32.215 0 0 1 3.345-3.127l-.002-.004c.1-.072.2-.146.299-.222 4.773-3.694 5.688-10.61 2.044-15.448-.923-1.908.296-4.042.296-4.042C8.318 5.69 9.917 6.94 9.917 6.94c.188.248.368.501.539.761 4.136 6.29 2.46 14.787-3.746 18.98l-.007.005a2.77 2.77 0 0 0-.085.066l-.024.02c-.51.393-.848.971-.943 1.612-.026.266-.012.535.044.796.072.253.257.831.477 1.06l.007-.019c.198-.842.9-1.466 1.75-1.556l.051-.028.017-.009h-.001l.012-.01c.307-.208.608-.427.9-.656 6.903-5.421 8.164-15.488 2.816-22.485h-.001l-.008-.005S10.37 4.082 9.94 3.328C9.012 1.707 8.784.086 8.783 0z",
    fill: "url(#t)",
    mask: "url(#u)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgTokenFinix);
export default __webpack_public_path__ + "static/media/img_token_finix.04de00c6.svg";
export { ForwardRef as ReactComponent };